<template>
  <AppModal
    class="confirmation-modal"
    :disabled="disabled || processing"
    :title="title"
    @close="handleClose"
  >
    <template #body>
      <p class="text-base pb-4">
        <slot />
      </p>

      <AppButtonGroup class="ml-auto w-fit">
        <AppButton
          class="btn btn-outline"
          :disabled="disabled || processing"
          @click="handleClose"
        >
          Cancel
        </AppButton>

        <AppButton
          :class="['btn-solid', confirmButtonColor]"
          :disabled="disabled || processing"
          @click="$emit('confirm')"
        >
          <!--          <FontAwesomeIcon-->
          <!--            v-if="processing"-->
          <!--            :icon="faSpinner"-->
          <!--            spin-->
          <!--          />-->

          {{ processing ? 'Deleting' : 'Delete' }}
        </AppButton>
      </AppButtonGroup>
    </template>
  </AppModal>
</template>

<script setup>
import { computed } from 'vue';

import { AppButton, AppButtonGroup, AppModal } from '@/components/app';
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  processing: {
    type: Boolean,
    default: false,
  },
  intent: {
    type: String,
    default: 'info',
    validator: value => ['info', 'success', 'danger'].includes(value),
  },
});

const emit = defineEmits(['confirm', 'close']);

const confirmButtonColor = computed(() => {
  return {
    'info': 'btn-info',
    'success': 'btn-success',
    'danger': 'btn-danger',
  }[props.intent];
});

const handleClose = () => {
  if (!props.disabled && !props.processing) {
    emit('close');
  }
};

</script>
